import { ProfileImage } from "@twioku/common_components";
import { Answerer } from "../../../api/generated";
import { Link } from "react-router-dom";
import { Path } from "../../../routes/PagePath";
import ChevronsRight from "../../../assets/chevrons_right.svg";

type Props = {
    answerer: Answerer;
};

export const QuestionAnswererItem = (props: Props) => {
    const { answerer } = props;
    return (
        <Link
            to={`${Path.questionList}/${answerer.answererId}`}
            className="mx-5 flex justify-between py-3"
        >
            <div className="flex">
                <ProfileImage src={answerer.profileImagePath} size="small" />
                <span className="my-auto block px-3">{answerer.name}</span>
            </div>
            <img className="w-7" src={ChevronsRight} alt="詳細へ進む" />
        </Link>
    );
};
